import axios from "axios"
import { baseURL } from "../config/api";

export const getReservationsOfReferece = (bookingNumber: string, email: string, tenantId: string) => {
    return axios({
        url: `${baseURL}MyReservation/GetMyReservationReport?bookingNumber=${bookingNumber}&email=${email}`,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
    }).then(response => response.data);
}